<template>
  <v-container grid-list-xl text-xs-center>
    <v-layout row wrap>
      <v-flex xs4 offset-xs4>
        <div class="completeRegistration">
          <v-text-field
            label="E-mail"
            type="userEmail"
            name="email"
            :rules="emailRules"
            v-model="userEmail" />
          <br>
          <v-text-field
            :label="$t('temp_password_label')"
            type="password"
            name="currentPassword"
            placeholder=""
            :rules="PasswordRules"
            v-model="currentPassword" />
          <br>
          <v-text-field
            :label="$t('new_password')"
            type="password"
            name="newPassword"
            :rules="PasswordRules"
            placeholder=""
            v-model="newPassword" />
          <br>
          <v-text-field
            :label="$t('confirm_password')"
            type="password"
            name="newPassword"
            :rules="MatchingPasswords"
            placeholder=""
            v-model="newPassword2" />
          <br>
          <v-text-field
            :label="$t('firstName')"
            type="text"
            name="userFirstName"
            placeholder=""
            v-model="userFirstName" />
          <br>
          <v-text-field
            :label="$t('lastName')"
            type="text"
            name="userLastName"
            placeholder=""
            v-model="userLastName" />
          <v-btn type="submit" @click="completeRegistration">{{ $t('completeRegistration') }}</v-btn>
        </div>
        <br>
        <div v-if="error" v-text="error"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AuthenticationService from '../services/AuthenticationService'
import Bugsnag from '../services/Bugsnag'

export default {
  name: 'CompleteRegistration',
  data () {
    return {
      newPassword: '',
      newPassword2: '',
      currentPassword: '',
      userFirstName: '',
      userLastName: '',
      error: null,
      emailRules: [
        v => !!v || this.$t('something_required', { something: 'E-mail' }),
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          this.$t('something_not_valid', { something: 'E-mail' })
      ],
      PasswordRules: [
        v => !!v || this.$t('password_required'),
        v => v.length > 7 || this.$t('password_requirements', { length: 8, numbers: 1 })
      ],
      MatchingPasswords: [
        v => !!v || this.$t('password_required'),
        v => v.length > 7 || this.$t('password_requirements', { length: 8, numbers: 1 }),
        v => v === this.newPassword || this.$t('password_not_match')
      ]
    }
  },

  computed: {
    userEmail: {
      get: function () {
        return this.$store.state.user.email
      },
      set: function (newValue) {
        this.$store.commit('setUserEmail', {email: newValue})
      }
    }
  },

  activated () {
    this.userEmail = localStorage.getItem('email')
  },

  methods: {
    async completeRegistration () {
      try {
        await AuthenticationService.completeRegistration({
          userEmail: this.userEmail,
          userFirstName: this.userFirstName,
          userLastName: this.userLastName,
          currentPassword: this.currentPassword,
          newPassword: this.newPassword
        })
        this.error = null
        this.$router.push('/transactions')
      } catch (error) {
        this.error = error.message
        Bugsnag.send(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CompleteRegistration.vue